import * as React from "react";

export const Label = ({ column }) => <label className="control-label">{column?.label || null}</label>;
